import React from 'react'

const CustomSelect = ({
  id,
  name,
  value,
  onChange,
  options,
  placeholder,
  t
}) => (
  <div className='flex items-center mb-3 ml-3'>
    <select
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      className='block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
      placeholder={placeholder}
    >
      <option defaultValue value=''>
        {t(placeholder)}
      </option>
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {t(option.label)}
        </option>
      ))}
    </select>
  </div>
)

export default CustomSelect
